import { useEffect } from "react";

import { useValues, useFormActions } from "2g-form/hooks";

export default function useRezervaceVytvoreniDatumOd() {
  const values = useValues() || {};
  const { setValue } = useFormActions();

  useEffect(() => {
    values.produkt?.produkt?.bezCasu &&
      values.datumOd === undefined &&
      setValue("datumOd", new Date().getTime());
  }, []);

  useEffect(() => {
    values.produkt?.produkt?.bezCasu && setValue("datumDo", values.datumOd);
  }, [values.datumOd]);

  return {
    visible: Boolean(values.produkt?.produkt.bezCasu)
  };
}
